import { render, staticRenderFns } from "./ShardInformation.vue?vue&type=template&id=0930ba4e&scoped=true"
import script from "./ShardInformation.vue?vue&type=script&lang=js"
export * from "./ShardInformation.vue?vue&type=script&lang=js"
import style0 from "./ShardInformation.scss?vue&type=style&index=0&id=0930ba4e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930ba4e",
  null
  
)

export default component.exports